angular
	.module 'App.Directive'
	.directive 'isolateForm', ->
		restrict: 'A'
		require: 'form'
		link: (scope, elem, attrs, ctrl) ->
			parentForm = ctrl.$$parentForm

			if !parentForm?
				return

			parentForm.$removeControl(ctrl)

